exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-11163e62] .colap-cont a{\n  text-decoration: underline !important;\n  cursor: pointer;\n}\n[data-v-11163e62] .colap-button:focus,[data-v-11163e62] .colap-button-down:focus {\n  background-color: #ffffff !important;\n  border: 3px solid #000000 !important;\n  outline: 3px solid #fcbc5c !important;\n  outline-offset: 0px;\n}\n.update-date[data-v-11163e62] {\n  text-align: right;\n  font-size: 12px;\n}\n", ""]);

// exports
